import axios from "axios";

const botToken = process.env.REACT_APP_TELEGRAM_BOT_TOKEN;
const chatId = process.env.REACT_APP_TELEGRAM_CHAT_ID;
const telegramApiUrl = `https://api.telegram.org/bot${botToken}/sendMessage`;

export const sendTelegramNotification = async (message) => {
  try {
    if (!botToken || !chatId) {
      console.error("Telegram bot token or chat ID not configured");
      return;
    }
    
    const response = await axios.post(telegramApiUrl, {
      chat_id: chatId,
      text: message,
      parse_mode: "HTML",
    });
    
    return response.data;
  } catch (error) {
    console.error("Error sending Telegram notification:", error);
    throw error;
  }
};